module.exports = __webpack_public_path__ + "assets/img/Type E (73).e88fe4c6.jpg";